import React from 'react';
import BaseClass from '@/pages/BaseClass';

import $ from 'jquery';
import {
	Table,
	Button,
	Input,
	Select,
	Row,
	Col,
	Image,
} from 'antd'
import {
	CommonValue,
	pcUrl,
	confirm,
	message,
	notify,
	httpPost
} from '@/utils/Tools';

const {Column,ColumnGroup} = Table;
export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'packageId':0,
			'siteId':1,
			
			'preview':{
				'visible':false,
				'src':'',
			},
			'info':{
				'packages':[],
				'image_list':[],
			},
		};
	}
	
	componentDidMount()
	{
		//this.state.packageId = this.props.match.params.id;
		let id = this.props.match.params.id;
		id = id.split('_');
		this.state.packageId = id[0];
		this.state.siteId = id[1] || 1;
		
		global.setRootState({
			'hideLayout':true,
		});
		this.getInfo();
		//document.title = '订单信息 - ' + CommonValue.get('site_name');
		document.title = '打包信息';
	}
	
	getInfo()
	{
		let url = pcUrl('package','detail');
		let param = {
			'package_id':this.state.packageId,
			'site_id':this.state.siteId
		};
		httpPost(url,param)
			.then(data=>{
				this.setState({
					'info':data,
				});
			});
	}
	
	showImage(imageName)
	{
		//打开图片预览
		this.setState({
			'preview':{
				'visible':true,
				'src':imageName,
			},
		});
	}
	
	render()
	{
		return (
			<div className="padding-20">
				<Table pagination={false} dataSource={this.state.info['image_list']} scroll={{'x':true}}>
					<Column title="正面" ellipsis={true} width={100} dataIndex="image_name" render={(text,row,index)=>(
						<>
							<div className="image-box" onClick={()=>this.showImage(row['image_path']['thumb_name'])}>
								<img src={row['image_path']['thumb_name']} />
							</div>
							{/*
							&nbsp;&nbsp;
							{row.image_name}
							*/}
						</>
					)} />
					<Column title="反面" ellipsis={true} width={100} dataIndex="back_path" render={(text,row,index)=>(
						<>
							{row['back_path'] ? (
								<div className="image-box" onClick={()=>this.showImage(row['back_path']['thumb_name'])}>
									<img src={row['back_path']['thumb_name']} />
								</div>
							):''}
						</>
					)} />
					<Column title="异形" ellipsis={true} width={100} dataIndex="spec_path" render={(text,row,index)=>(
						<>
							{row['spec_path'] ? (
								<a href={row['spec_path']} target="_blank">下载</a>
							):''}
						</>
					)} />
					<Column title="数量" ellipsis={true} width={100} dataIndex="package"  render={(text,row,index)=>this.state.info['packages'][index]}/>
					<Column title="材料" ellipsis={true} width={100} dataIndex="categories" width={100} render={(text,row,index)=>(
						<>
							{row['categories'][1].map(row=>(
								<>
									{row}
									<br />
								</>
							))}
						</>
					)} />
					<Column title="图片尺寸" ellipsis={true} width={100} dataIndex="image_dimension" render={(text,row,index)=>(
						<>
							{row['image_dimension'].split('*').map(row=>row+'CM').join('*')}
						</>
					)} />
					{/*
					<Column title="单价" ellipsis={true} width={100} dataIndex="image_price" render={(text,row,index)=>'￥'+row['image_price']} />
					<Column title="原价" ellipsis={true} width={100} dataIndex="image_amount" render={(text,row,index)=>'￥'+row['image_amount']} />
					<Column title="应付金额" ellipsis={true} width={100} dataIndex="pay_amount" render={(text,row,index)=>'￥'+row['pay_amount']} />
					<Column title="状态" ellipsis={true} width={100} dataIndex="image_status_exp" />
					*/}
				</Table>
				<Image preview={{...this.state.preview,'onVisibleChange':val=>{let preview = this.state.preview; preview.visible = val; this.setState({'preview':{...preview}});}}} />
				
			</div>
		);
	}
}



